module.exports = __webpack_public_path__ + "static/media/a-Approx.140c975f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/a-Approx.png
// module id = 144
// module chunks = 0